import { DateTime } from 'luxon';
/**
 * Transforme une date UTC en format ISO-8601
 * @param date Date en string
 */
export const toISODate = (date: string): string => {
    return DateTime.fromISO(date).toISODate();
};

/**
 * Transforme une date UTC en format ISO-8601
 * @param referenceDate Date de référence en string
 * @param testedDate Date à comparer avec la date de référence (referenceDate) en string
 */
 export const compareDate = (referenceDate: string, testedDate: string): number => {
    const date1 = toISODate((new Date(referenceDate)).toISOString());
    const date2 = toISODate((new Date(testedDate)).toISOString());
    let compareResult: number;
    if (+date1 === +date2) {
        compareResult = 0;
    } else if (date1 < date2) {
        compareResult = -1;
    } else {
        compareResult = 1;
    }

    return compareResult;
};
